// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 234) return "static/chunks/234-1d414d4abfda1cec.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "30648520d643fef2" + ".js";
};